<ng-container *ngIf="notification">
  <trp-banner [dismissable]="false" [bannerType]="'info'">
    <ng-container banner-content>
      {{
        'banner.verifyEmail.text' | translate : { email: notification.content.email }
      }}
    </ng-container>

    <button
      trpBannerAction
      mat-stroked-button
      (click)="sendVerificationEmail({ error: error, success: success })"
      [disabled]="state === 'pending'"
    >
      <ng-container *ngIf="state === 'idle'">
        {{ 'banner.verifyEmail.sendEmail' | translate }}
      </ng-container>
      <ng-container *ngIf="state === 'pending'">
        {{ 'banner.verifyEmail.sendingEmail' | translate }}
      </ng-container>
    </button>
  </trp-banner>

  <ng-template #error
    ><mat-icon>warning</mat-icon>
    {{ 'banner.verifyEmail.error' | translate }}</ng-template
  >
  <ng-template #success
    ><mat-icon>check</mat-icon>
    {{
      'banner.verifyEmail.success' | translate : { email: notification.content.email }
    }}</ng-template
  >
</ng-container>
